export default __webpack_public_path__ + "static/shadow-card-a360fbd456d36074a0976b770578d3d9.svg";